var sortByValue = function (number1, number2) {
    return +number1 - +number2;
};
var trimZeros = function (v) {
    var _a;
    return (_a = v === null || v === void 0 ? void 0 : v.toString()) === null || _a === void 0 ? void 0 : _a.replace(/(\.\d*?[1-9]+)0+$|\.0+$/g, "$1");
};
var numberOfDecimals = function (v) {
    var _a, _b;
    return ((_b = (_a = v === null || v === void 0 ? void 0 : v.toString()) === null || _a === void 0 ? void 0 : _a.split(".")[1]) !== null && _b !== void 0 ? _b : "").length;
};

export { numberOfDecimals, sortByValue, trimZeros };
